
class Cookies {
    constructor() {
        if (!Cookies.hasCookiesAcceptation()) {
            this.initComponent();
        }
    }

    static hasCookiesAcceptation() {
        return window.localStorage.getItem('cookiesAcceptation');
    }

    static createEntity() {
        window.localStorage.setItem('cookiesAcceptation', 'true');
    }

    initComponent() {
        this.buildTemplate();
        this.attachEvents();
    }

    buildTemplate() {
        this.element = document.createElement('div');
        this.element.classList.add('cookies');
        this.element.innerHTML = `
        <div class="container">
            <div class="cookies__inner">
                <div class="text-md cookies__text">Этот сайт использует файлы cookies и сервисы сбора технических данных посетителей (данные об IP-адресе, местоположении и др.) для обеспечения работоспособности и улучшения качества обслуживания. Продолжая использовать наш сайт, вы автоматически соглашаетесь с использованием данных технологий.</div>
                <button class="button cookies__button jsCookiesButton" type="button">
                    <span>Принять и закрыть</span>
                </button>
            </div>
        </div>
        `;
        
        document.body.append(this.element);

        setTimeout(() => {
            document.querySelector('.cookies').classList.add('is-show');
        }, 2000);
    }

    attachEvents() {
        document.querySelector('.jsCookiesButton').addEventListener('click', (e) => {
            Cookies.createEntity();
            document.querySelector('.cookies').classList.remove('is-show');

            setTimeout(() => {
            this.element.remove();
            }, 750);
        });
    }
}

export default Cookies;
